import history from "history.js";
import api, { globalErrorHandler } from "../Api";
import jwtDecode from "jwt-decode";

import {
  LOGIN_ERROR,
  LOGIN_SUCCESS,
  LOGIN_LOADING,
  LOGIN_CLEAR,
  LOADING_CLEAR,
  LOGIN_ERROR_SESSION_ACTIVE,
  CA_SET_ERROR,
  SET_USER_DATA,
} from "./ActionTypes";

export function login({ loginUser, token }) {
  return (dispatch) => {
    dispatch({
      type: LOGIN_LOADING,
    });

    const parameters = {
      login: loginUser,
      token: token,
    };
    return api
      .post(`/authenticate/LoadUserData`, parameters)
      .then((response) => {
        // Set user
        dispatch({
          type: SET_USER_DATA,
          data: jwtDecode(response.data.token),
        });

        if (history.location.prev) {
          history.push({
            pathname:
              history.location.pathname != history.location.prev
                ? history.location.prev
                : "/",
          });
        } else {
          history.push({
            pathname:
              history.state && history.state != "/session/signin"
                ? history.state
                : "/",
          });
        }

        return dispatch({
          type: LOGIN_SUCCESS,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response && error.response.status === 409)
          return dispatch({
            type: LOGIN_ERROR_SESSION_ACTIVE,
            data: `${error.response.data}. If you want to continue and close the active session click Sign in again.`,
          });
        if (error && error.response && error.response.status === 400) {
          const msg =
            typeof error.response.data === "string"
              ? error.response.data
              : "Your session has expired. Please refresh the page and sign in again.";
          return dispatch({ type: LOGIN_ERROR, data: msg });
        }
        if (error && error.response) {
          const data = error.response.data;
          const msg =
            typeof data === "string"
              ? data
              : data?.message || data?.Message || "An error occurred. Please try again or refresh the page.";
          return dispatch({ type: LOGIN_ERROR, data: msg });
        }
      });
  };
}

export const clearLogin = () => {
  // console.log("mensaje de error", error)
  return (dispatch) => {
    dispatch({
      type: LOGIN_CLEAR,
    });
  };
};

export const clearLoading = () => {
  // console.log("mensaje de error", error)
  return (dispatch) => {
    dispatch({
      type: LOADING_CLEAR,
    });
  };
};

export const setError = (error) => {
  // console.log("mensaje de error", error)
  return (dispatch) => {
    dispatch({
      data: error,
      type: CA_SET_ERROR,
    });
  };
};

export const refreshtoken = (refreshtoken) => {
  return async (dispatch) => {
    if (!refreshtoken) return Promise.reject(new Error("No refresh token"));
    let response;
    try {
      response = await api.post(
        `/authenticate/refresh`,
        { refreshToken: refreshtoken },
        { headers: { "Content-Type": "application/json" } }
      );
    } catch (err) {
      if (err && err.response) globalErrorHandler(err);
      return Promise.reject(err);
    }
    if (!response || !response.data || !response.data.token) return Promise.reject(new Error("Invalid refresh response"));
    dispatch({
      type: LOGIN_SUCCESS,
      data: response.data,
    });
    dispatch({
      type: "SET_USER_DATA",
      data: jwtDecode(response.data.token),
    });
    return response.data.token;
  };
};
